export default "/images/edit.svg?f9a985514490b053354591cb888b8cf9";